export enum GenericEngagementDataPatrimonyEnum {
  EQUIPMENT = 'Equipement GEN',
  REFERENCE = 'Référence GEN',
  BUILDING = 'Bâtiment GEN',
  ID_ENERGIE = 'ID Energie',
}

export enum GenericEngagementEquipmentCondEnum {
  MAINTENANCE_EQ = 'Maintenance EQ',
  MAINTENANCE_EQ_AC = 'Maintenance EQ (achat pièces détachées)',
  MAINTENANCE_REG = 'Contrôle règlementaire EQ (forfait intervention)',
  LOCATION_EQ = 'Location EQ',
  ACQUISITION_EQ = 'Acquisition EQ',
  PRODUCT = 'Articles',
}

export enum GenericEngagementReferenceCondEnum {
  ARTICLES = 'Articles',
  PRESTATIONS = 'Prestations',
}

export enum GenericBuildingCondENum {
  MAINTENANCE_BAT = 'Maintenance Bâtiment',
  MAINTENANCE_BAT_AC = 'Maintenance Bâtiment (achat fournitures)',
  MAINTENANCE_REG = 'Contrôle réglementaire Bâtiment (forfait intervention)',
  BUILDING_LOCATION = 'Location Bâtiment',
  BUILDING_ACQUISITION = 'Acquisition Bâtiment',
}

/**
 * Unités catalogue qui donnent lieu à un onglet « Prestations » dans le catalogue fournisseur.
 * Règle métier (PRED-3239) : Maintenance / Contrôle réglementaire / Location = prestation.
 */
export const CATALOG_PRESTATION_UNITS: string[] = [
  GenericEngagementReferenceCondEnum.PRESTATIONS,
  GenericBuildingCondENum.MAINTENANCE_BAT,
  GenericBuildingCondENum.MAINTENANCE_REG,
  GenericBuildingCondENum.BUILDING_LOCATION,
  GenericEngagementEquipmentCondEnum.MAINTENANCE_EQ,
  GenericEngagementEquipmentCondEnum.MAINTENANCE_REG,
  GenericEngagementEquipmentCondEnum.LOCATION_EQ,
];

/**
 * Unités catalogue qui donnent lieu à un onglet « Articles » dans le catalogue fournisseur.
 * Règle métier (PRED-3239) : achat de pièces / fournitures / Acquisition / Articles = article.
 */
export const CATALOG_ARTICLE_UNITS: string[] = [
  GenericEngagementReferenceCondEnum.ARTICLES,
  GenericBuildingCondENum.MAINTENANCE_BAT_AC,
  GenericBuildingCondENum.BUILDING_ACQUISITION,
  GenericEngagementEquipmentCondEnum.MAINTENANCE_EQ_AC,
  GenericEngagementEquipmentCondEnum.ACQUISITION_EQ,
  GenericEngagementEquipmentCondEnum.PRODUCT,
];
